"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BackdropComponent = _interopRequireDefault(require("../backdrop/BackdropComponent"));

require("./LoaderComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoaderComponent = function LoaderComponent(_ref) {
  var spinning = _ref.spinning,
      isBackdrop = _ref.isBackdrop,
      bottomAlign = _ref.bottomAlign;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isBackdrop && /*#__PURE__*/_react["default"].createElement(_BackdropComponent["default"], {
    show: spinning ? spinning : false
  }), bottomAlign && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-bottom"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-text"
  })) || /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader-text"
  }))));
};

var _default = LoaderComponent;
exports["default"] = _default;